import { EventCard } from "@on-site/features/event/ui/EventCard";
import type { RadioEventCardProps } from "./type";

import clsx from "clsx";
import { RadioCheckIcon, RadioCheckOffIcon } from "@fanka/ui-admin";

export const RadioEventCard = ({ event, isSelected = false, onClick }: RadioEventCardProps) => (
  <button className={clsx("relative w-full", isSelected && "shadow-mid")} onClick={onClick}>
    <div className="absolute left-4 top-4">{isSelected ? <RadioCheckIcon /> : <RadioCheckOffIcon />}</div>
    <EventCard event={event} />
  </button>
);
